import { render, staticRenderFns } from "./UserPasswordChanged.vue?vue&type=template&id=0322c788&scoped=true"
import script from "./UserPasswordChanged.vue?vue&type=script&lang=js"
export * from "./UserPasswordChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0322c788",
  null
  
)

export default component.exports